import { MapGroupId } from "../../types";
import img from "../../mapImages/ShorelineKeys.webp";

const mapData = {
  groupId: MapGroupId.Shoreline,
  groupName: {
    en: "Shoreline",
    ru: "Берег",
  },
  title: {
    en: "Keys",
    ru: "Ключи",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
